import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable, catchError, map, of } from 'rxjs';

import { EnvironmentConfig } from '../config/environment.config';
import { Comment } from '../models/comment.model';
import { CommentType } from '../models/comment-type.constat';

@Injectable({
  providedIn: 'root'
})
export class CommentsService {
  constructor(
    @Inject('environment') private environment: EnvironmentConfig,
    private http: HttpClient
  ) {}

  getComments(id: string, typeId: CommentType): Observable<Comment[]> {
    return this.http.get<Comment[]>(`${this.environment.endPoint}comments?id=${id}&typeId=${typeId}`).pipe(
      map((comments) => comments?.map((comment) => this.mapToGenericComment(comment, comments)).filter((c) => !c.replyToCommentId)),
      catchError(() => of([]))
    );
  }

  postComment(comment: Comment): Observable<Comment> {
    return this.http.post<Comment>(`${this.environment.endPoint}comments`, comment).pipe(catchError(() => of(null)));
  }

  resolveComment(commentId: string): Observable<boolean> {
    return this.http.post<boolean>(`${this.environment.endPoint}comments/${commentId}/resolve`, {}).pipe(catchError(() => of(null)));
  }

  private mapToGenericComment(serverComment: Comment, comments: Comment[]): Comment {
    return { ...serverComment, replies: comments.filter((replies) => replies.replyToCommentId === serverComment.id) };
  }
}
